import React from 'react';
import DigitalMarketingHero from '../components/DigitalMarketingHero';
import DigitalMarketingAgencySection from '../components/DigitalMarketingAgencySection';
import TopDigitalMarketingAgency from '../components/TopDigitalMarketingAgency';
import DigitalMarketingAuditSection from '../components/DigitalMarketingAuditSection';
import DigitalMarketingPortfolio from '../components/DigitalMarketingPortfolio';
import WhyChooseDigitalMarketing from '../components/WhyChooseDigitalMarketing';
import DigitalMarketingServicesStack from '../components/DigitalMarketingServicesStack';
import DigitalMarketingLogosSlider from '../components/DigitalMarketingLogosSlider';
import WhyChooseDigitalMarketingServices from '../components/WhyChooseDigitalMarketingServices';
import DigitalMarketingDifferentiators from '../components/DigitalMarketingDifferentiators';
import DigitalMarketingTestimonialsSlider from '../components/DigitalMarketingTestimonialsSlider';
import Counters from '../components/Counters';
import ContactUs from '../components/ContactUs';

const clientsServedIcon = (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const projectsIcon = (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
    <polyline points="10 11 8 13 10 15" />
    <polyline points="14 11 16 13 14 15" />
  </svg>
);

const trustpilotIcon = (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" />
    <path d="M6.5 13.5c0-1.8 2.5-2.5 5.5-2.5s5.5.7 5.5 2.5" />
    <polygon points="12,14 13.2,16.5 16,16.8 14,18.7 14.5,21.5 12,20.1 9.5,21.5 10,18.7 8,16.8 10.8,16.5" />
    <polygon points="6,16 6.8,17.8 8.8,18 7.4,19.4 7.8,21.4 6,20.4 4.2,21.4 4.6,19.4 3.2,18 5.2,17.8" />
    <polygon points="18,16 18.8,17.8 20.8,18 19.4,19.4 19.8,21.4 18,20.4 16.2,21.4 16.6,19.4 15.2,18 17.2,17.8" />
  </svg>
);

const experienceIcon = (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="14" width="3" height="7" rx="0.5" />
    <rect x="8" y="10" width="3" height="11" rx="0.5" />
    <rect x="13" y="6" width="3" height="15" rx="0.5" />
    <rect x="18" y="2" width="3" height="19" rx="0.5" />
    <path d="M3 10c4-4 10-7 18-7m0 0v5m0-5h-5" />
  </svg>
);

const digitalMarketingCountersData = [
  { target: 100, suffix: '+', text: 'Clients Served', icon: clientsServedIcon },
  { target: 300, suffix: '+', text: 'Successful Projects', icon: projectsIcon },
  { target: 4.8, decimals: 1, text: 'Trustpilot Rating', icon: trustpilotIcon },
  { target: 10, suffix: '+', text: 'Years of Experience', icon: experienceIcon }
];

function DigitalMarketingPage() {
  return (
    <>
      <DigitalMarketingHero />
      <DigitalMarketingAgencySection />
      <TopDigitalMarketingAgency />
      <DigitalMarketingAuditSection />
      <DigitalMarketingPortfolio />
      <WhyChooseDigitalMarketing />
      <DigitalMarketingServicesStack />
      <DigitalMarketingLogosSlider />
      <WhyChooseDigitalMarketingServices />
      <Counters data={digitalMarketingCountersData} />
      <DigitalMarketingDifferentiators />
      <DigitalMarketingTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default DigitalMarketingPage;
